import script from "./ProjectFollowLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectFollowLog.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectFollowLog.vue?vue&type=style&index=0&id=5e8e5614&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8e5614"]])

export default __exports__